import React, { useEffect, useState } from "react"
import {
  GroupDetailsGroupName,
  GroupDetailsRegion,
  GroupDetailsRegionHeading,
  GroupDetailsRegionList,
  GroupDetailsRegionWrapper,
  RoleIdText,
} from "./Atom"
import { Box, CircularProgress, Typography } from "@mui/material"
import ArrowRightIcon from "@mui/icons-material/ArrowRight"
import { useDispatch, useSelector } from "react-redux"
import { useNavigate } from "react-router-dom"
import { getTokenLocal } from "../../../../../../../helper/utils"
import { useResponseHandle } from "../../../../../../hooks"
import { setGroupDetailsPracticeresult } from "../../../../../../redux/slices/groupProfileSlice"
import { setOfficeManagersData } from "../../../../../../redux/slices/usersSlice"
import AdminAPI from "../../../../../../../api/admin"

const adminAPI = new AdminAPI()

function OfficeManagerListTabs({ group_sk }: any) {
  const token: any = getTokenLocal()
  const dispatch = useDispatch()
  const navigate = useNavigate()

  const [selected, setSelected] = useState(0)
  const [selectedOffice, setSelectedOffice] = useState<any>([])

  const officeManagers = useSelector((state: any) => {
    return state.users.officeManagersData
  })

  const fetchOfficeManager = async () => {
    const response = await adminAPI.getOfficeManagers(token, group_sk)

    const result = useResponseHandle({
      apiResponse: response,
      successMessage: false,
    })

    if (result?.isAuthorized) {
      if (result?.statusCode == 200) {
        dispatch(setOfficeManagersData(result?.data))
      }
    } else navigate("/auth")

    return result
  }

  useEffect(() => {
    fetchOfficeManager()
  }, [group_sk])

  useEffect(() => {
    if (officeManagers.length > 0) {
      setSelectedOffice(officeManagers[selected]["office_managers"])
    }
  }, [selected, officeManagers])

  return (
    <Box sx={{ display: "flex", height: "100%" }}>
      <GroupDetailsRegion>
        <GroupDetailsRegionWrapper>
          <GroupDetailsRegionHeading>Offices</GroupDetailsRegionHeading>
          {officeManagers.length > 0 ? (
            officeManagers?.map((office: any, officeIndex: any) => {
              return (
                <Box
                  key={officeIndex}
                  sx={{
                    backgroundColor: selected === officeIndex ? "#4A79E7" : "",
                    color: selected === officeIndex ? "#fff" : "",
                    cursor: "pointer",
                    border: "1px solid #E3E3E3",
                  }}
                  onClick={() => {
                    setSelected(officeIndex)
                  }}
                >
                  <GroupDetailsRegionList>
                    {office.name} <ArrowRightIcon />
                  </GroupDetailsRegionList>
                </Box>
              )
            })
          ) : (
            <Typography sx={{ padding: "2rem" }}>
              No Offices assigned
            </Typography>
          )}
        </GroupDetailsRegionWrapper>
      </GroupDetailsRegion>
      {selectedOffice.length > 0 ? (
        <Box
          sx={{
            width: "30%",
            height: "fit-content",
            border: "1px solid #E3E3E3",
            borderLeft: "none",
          }}
        >
          {selectedOffice?.map((manager: any, managerIndex: any) => {
            return (
              <li
                key={managerIndex}
                style={{
                  listStyle: "none",
                  padding: "22px 20px",
                  fontSize: "14px",
                  color: "#000",
                  fontWeight: "bold",
                  borderBottom: "1px solid #E5E5E5",
                }}
              >
                {manager.name}
                <RoleIdText>{manager.role_display_name}</RoleIdText>
              </li>
            )
          })}
        </Box>
      ) : (
        <Typography sx={{ padding: "2rem" }}>
          No office Managers assigned
        </Typography>
      )}

      {/* {groupDetailsPracticeresult?.length > 0 ? (
        <Box
          sx={{
            // width: "100%",
            height: "100%",
            // border: "1px solid red",
            padding: "70px 50px",
          }}
        >
          <span
            style={{
              color: "#6F7070",
              fontSize: "12px",
              padding: "16px 17px",
            }}
          >
            Offices
          </span>
          {groupDetailsPracticeresult?.map((practice: any, itemIndex: any) => {
            return (
              <li
                style={{
                  listStyle: "none",
                  padding: "16px",
                  fontSize: "14px",
                  color: "#000",
                  fontWeight: "bold",
                }}
              >
                {practice?.name}
              </li>
            )
          })}
        </Box>
      ) : (
        <Box
          sx={{
            flex: 1,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            //     border: "1px solid red"
          }}
        >
          <CircularProgress />
        </Box>
      )} */}
    </Box>
  )
}

export default OfficeManagerListTabs
